import {
  murnAddressFromFormkit,
  murnAddressToFormkit,
  plainMurnAddressFromFormkit,
  plainMurnAddressToFormkit,
} from "@modernary/mui/components/fk";

import { type Facility, type FacilityFormKit, type FacilityNew } from "@/views/facility/facility";
import { fillAddressLookupValues, fillPrefixedAddressLookupValues } from "@modernary/mui/components/lookup";
import { taxMapKeyAdapter } from "@modernary/mui/components/taxMapKey";

export default {
  addAuthRequestFields,
  getInitialData,
  fromFormkit,
  toFormkit,
  skinnyResponseAdapter,
  responseAdapter,
  formatDisplayName,
};

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Facility }) {
  addAuthRequestFields(response.data);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Facility }) {
  await skinnyResponseAdapter(response);
  await fillAddressLookupValues(response.data);
  return response.data;
}

function addAuthRequestFields(entity: Facility | FacilityNew) {
  entity._authRequestFields = ["id", "statusMurn"] as (keyof Facility)[];
  return entity;
}

function getInitialData() {
  const result = {} as Facility; //TODO:TS
  return addAuthRequestFields(result);
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Facility) {
  plainMurnAddressToFormkit(data);
  if (data.latitudeLongitude) {
    (data as FacilityFormKit).latitudeLongitudeVal = {
      latitude: data.latitudeLongitude.coordinates[1],
      longitude: data.latitudeLongitude.coordinates[0],
    };
  }
  taxMapKeyAdapter(data as Facility);
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: FacilityFormKit) {
  plainMurnAddressFromFormkit(data as Facility);
  if (data.latitudeLongitudeVal?.latitude && data.latitudeLongitudeVal?.longitude) {
    data.latitude = data.latitudeLongitudeVal.latitude;
    data.longitude = data.latitudeLongitudeVal.longitude;
  }
}

function formatDisplayName(facility: Facility) {
  return facility.name + (facility.identifier ? ` (${facility.identifier})` : "");
}
